import { BaseConfiguration } from './base-configuration.model';
import { ReferenceSystem } from './reference-system.enum';

export class StaticConfiguration extends BaseConfiguration {
  totalNumberOfIncrements: number;

  constructor() {
    super();
    this.cutoff = 0;
    this.displacementAndRotationNorm = true;
    this.maximumUnbalancedForce = true;
    this.forceAndMomentumNorm = true;
    this.maximumUnbalancedMoment = false;
    this.totalNumberOfIncrements = 11;
    this.maxNumberOfIterations = 40;
    this.convergenceErrorTolerance = 0.001;
    this.maxUnbalancedForce = 1;
    this.maxUnbalancedMoment = 1;
    this.referenceSystem = ReferenceSystem.LOCAL_FLOATING;
  }
}
